import React from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { checkIfEmpty, validate } from "./validation/PasswordForm";
import trimString from "../../../utils/trimString";

const renderField = (props) => {
  const {
    input,
    type,
    placeholder,
    className,
    meta: { error },
  } = props;
  let errorToShow;

  if (Array.isArray(error) && error.length) {
    errorToShow = error[0];
  } else {
    errorToShow = error;
  }
  return (
    <div className="w-100">
      <input
        {...input}
        className={className}
        type={type}
        placeholder={placeholder}
      ></input>
      {errorToShow ? (
        <div className="errorMsg mar-t-3">{errorToShow}</div>
      ) : null}
    </div>
  );
};

const ChangePassword = (props) => {
  const {
    handleSubmit,
    resetPasswordAccount,
    closeChangePasswordModal,
  } = props;

  const submit = (fields) => {
    const response = checkIfEmpty(fields);

    if (Object.keys(response).length) {
      throw new SubmissionError(response);
    }

    resetPasswordAccount({
      newPassword: trimString(fields.newPassword),
      oldPassword: trimString(fields.oldPassword),
    });
  };

  const changePasswordText = `For your security, you may need to reenter your bank account information once your password is reset.`;

  return (
    <form onSubmit={handleSubmit(submit)}>
      <p className="change-pw-instructions">
        {`Password must be at least eight characters in length and contain at least one uppercase letter, one lowercase letter, one number, and one of the following special characters: @$!%*?&. `}
        {changePasswordText}
      </p>
      <div className="modal-input-mar-b-20">
        <Field
          name="oldPassword"
          component={renderField}
          type="password"
          placeholder="Old Password"
          className="cc-input"
        />
      </div>
      <div className="modal-input-mar-b-20">
        <Field
          name="newPassword"
          component={renderField}
          type="password"
          placeholder="New Password"
          className="cc-input"
        />
      </div>
      <div className="modal-input-mar-b-20">
        <Field
          name="reenterNewPassword"
          component={renderField}
          type="password"
          placeholder="Re-enter New Password"
          className="cc-input"
        />
      </div>
      <div className="modal-input-mar-b-20">
        <div className="modal-input-flex-2-pad-r-10">
          <button type="submit" className="acct-pg-btn acct-pg-btn-block">
            Submit
          </button>
        </div>
        <div className="modal-input-pad-l-10">
          <div
            className="acct-pg-btn-inverse acct-pg-btn-block"
            onClick={closeChangePasswordModal}
          >
            Close
          </div>
        </div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "changePassword",
  validate,
  enableReinitialize: true,
})(ChangePassword);
